export default __webpack_public_path__ + "static/media/form-recover-snet.44e726cf.svg";